import {NgModule} from '@angular/core';
import {EnumToArrayPipe} from './pipes/enum-to-array/enum-to-array.pipe';
import {TimeNumberToStringPipe} from './pipes/time-number-to-string/time-number-to-string.pipe';
import {TimeStringToNumberPipe} from './pipes/time-string-to-number/time-string-to-number.pipe';
import {DurationToStringPipe} from './pipes/duration-to-string/duration-to-string.pipe';
import {GroupTreeComponent} from './components/group-tree/group-tree.component';
import {AngularMaterialModule} from './angular-material.module';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {LocalTimeNumberToStringPipe} from './pipes/local-time-number-to-string/local-time-number-to-string.pipe';
import { DurationFormatPipe } from './pipes/duration-format/duration-format.pipe';

@NgModule({
  imports: [
    AngularMaterialModule,
    TranslateModule,
    CommonModule
  ],
  declarations: [
    EnumToArrayPipe,
    TimeNumberToStringPipe,
    TimeStringToNumberPipe,
    DurationToStringPipe,
    LocalTimeNumberToStringPipe,
    GroupTreeComponent,
    DurationFormatPipe
  ],
  exports: [
    EnumToArrayPipe,
    TimeNumberToStringPipe,
    TimeStringToNumberPipe,
    DurationToStringPipe,
    LocalTimeNumberToStringPipe,
    GroupTreeComponent,
    DurationFormatPipe
  ]
})
export class WebofficeCommonSharedModule {
}
